(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pretty-selfish-card-game"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGame = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const cards = [...root.querySelectorAll('.ps-card-game__card')];
      const count = root.querySelector('.ps-card-game__count');
      const complete = root.querySelector('.ps-card-game__complete');
      const prizeData = root.querySelector('.ps-card-game__prizes');
      const required = Math.min(
        Number(root.dataset.requiredPicks) || 4,
        cards.length
      );
      const redirectUrl = root.dataset.redirectUrl;
      const redirectDelay = Number(root.dataset.redirectDelay) || 2500;
      const confettiDuration = Number(root.dataset.confettiDuration) || 3000;
      let prizes = [];
      let selected = 0;
      let finished = false;

      try {
        prizes = JSON.parse(prizeData.textContent);
      } catch (error) {
        console.error('Pretty Selfish card-game prize data is invalid.', error);
      }

      const fillPrize = (card, prize) => {
        const media = card.querySelector('.ps-card-game__prize-media');
        const title = card.querySelector('.ps-card-game__prize-title');
        const caption = card.querySelector('.ps-card-game__prize-caption');

        if (prize.image) {
          const image = document.createElement('img');
          image.src = prize.image;
          image.alt = prize.imageAlt || '';
          image.loading = 'eager';
          media.replaceChildren(image);
        } else {
          const icon = document.createElement('span');
          icon.className = 'ps-card-game__prize-icon';
          icon.textContent = prize.icon || '🎁';
          media.replaceChildren(icon);
        }

        title.textContent = prize.title || '';
        caption.textContent = prize.caption || '';
      };

      const launchConfetti = () => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const canvas = root.querySelector('.ps-card-game__confetti');
        const context = canvas.getContext('2d');
        const colors = ['#e8256a', '#f7b7cb', '#ffffff', '#ffd34e', '#8d55c7'];
        let pieces = [];
        let animationFrame;
        const startedAt = performance.now();

        const resize = () => {
          const ratio = Math.min(window.devicePixelRatio || 1, 2);
          const bounds = root.getBoundingClientRect();
          canvas.width = bounds.width * ratio;
          canvas.height = bounds.height * ratio;
          canvas.style.width = `${bounds.width}px`;
          canvas.style.height = `${bounds.height}px`;
          context.setTransform(ratio, 0, 0, ratio, 0, 0);
        };

        resize();
        pieces = Array.from({ length: 190 }, () => ({
          x: Math.random() * canvas.clientWidth,
          y: -20 - Math.random() * canvas.clientHeight * 0.65,
          w: 5 + Math.random() * 8,
          h: 8 + Math.random() * 12,
          vx: -1.7 + Math.random() * 3.4,
          vy: 2.5 + Math.random() * 4.5,
          spin: -0.18 + Math.random() * 0.36,
          angle: Math.random() * Math.PI,
          color: colors[Math.floor(Math.random() * colors.length)]
        }));

        const draw = (now) => {
          context.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight);
          pieces.forEach((piece) => {
            piece.x += piece.vx;
            piece.y += piece.vy;
            piece.vy += 0.025;
            piece.angle += piece.spin;
            context.save();
            context.translate(piece.x, piece.y);
            context.rotate(piece.angle);
            context.fillStyle = piece.color;
            context.fillRect(-piece.w / 2, -piece.h / 2, piece.w, piece.h);
            context.restore();
          });

          if (now - startedAt < confettiDuration) {
            animationFrame = requestAnimationFrame(draw);
          } else {
            context.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight);
          }
        };

        animationFrame = requestAnimationFrame(draw);
        window.addEventListener('resize', resize, { once: true });
        root.addEventListener('shopify:section:unload', () => cancelAnimationFrame(animationFrame), { once: true });
      };

      const finishGame = () => {
        if (finished) return;
        finished = true;
        cards.forEach((card) => {
          card.disabled = true;
        });
        launchConfetti();

        window.setTimeout(() => {
          complete.hidden = false;
          requestAnimationFrame(() => complete.classList.add('is-visible'));
        }, 650);

        if (redirectUrl && !(window.Shopify && window.Shopify.designMode)) {
          window.setTimeout(() => {
            window.location.assign(redirectUrl);
          }, redirectDelay);
        }
      };

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          if (finished || card.classList.contains('is-flipped') || selected >= required) return;

          const prize = prizes[selected] || {
            title: 'Prize unlocked',
            caption: '',
            image: '',
            icon: '🎁'
          };

          fillPrize(card, prize);
          card.classList.add('is-flipped');
          card.setAttribute('aria-pressed', 'true');
          card.querySelector('.ps-card-game__face--front').setAttribute('aria-hidden', 'false');
          selected += 1;
          count.textContent = `${selected}/${required}`;

          root.dispatchEvent(new CustomEvent('pretty-selfish:card-flipped', {
            bubbles: true,
            detail: { selected, required, prize: prize.title }
          }));

          if (selected === required) {
            window.setTimeout(finishGame, 720);
          }
        });
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('.ps-card-game').forEach(initGame);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pretty-selfish-halloween-game"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGame = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const cards = [...root.querySelectorAll('.ps-card-game__card')];
      const count = root.querySelector('.ps-card-game__count');
      const complete = root.querySelector('.ps-card-game__complete');
      const prizeData = root.querySelector('.ps-card-game__prizes');
      const required = Math.min(
        Number(root.dataset.requiredPicks) || 4,
        cards.length
      );
      const redirectUrl = root.dataset.redirectUrl;
      const redirectDelay = Number(root.dataset.redirectDelay) || 2500;
      const confettiDuration = Number(root.dataset.confettiDuration) || 3000;
      let prizes = [];
      let selected = 0;
      let finished = false;

      try {
        prizes = JSON.parse(prizeData.textContent);
      } catch (error) {
        console.error('Pretty Selfish card-game prize data is invalid.', error);
      }

      const fillPrize = (card, prize) => {
        const media = card.querySelector('.ps-card-game__prize-media');
        const title = card.querySelector('.ps-card-game__prize-title');
        const caption = card.querySelector('.ps-card-game__prize-caption');

        if (prize.image) {
          const image = document.createElement('img');
          image.src = prize.image;
          image.alt = prize.imageAlt || '';
          image.loading = 'eager';
          media.replaceChildren(image);
        } else {
          const icon = document.createElement('span');
          icon.className = 'ps-card-game__prize-icon';
          icon.textContent = prize.icon || '🎁';
          media.replaceChildren(icon);
        }

        title.textContent = prize.title || '';
        caption.textContent = prize.caption || '';
      };

      const launchConfetti = () => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const canvas = root.querySelector('.ps-card-game__confetti');
        const context = canvas.getContext('2d');
        const colors = ['#ff7a19', '#a85ad4', '#fff0c7', '#17101f', '#53b86b'];
        let pieces = [];
        let animationFrame;
        const startedAt = performance.now();

        const resize = () => {
          const ratio = Math.min(window.devicePixelRatio || 1, 2);
          const bounds = root.getBoundingClientRect();
          canvas.width = bounds.width * ratio;
          canvas.height = bounds.height * ratio;
          canvas.style.width = `${bounds.width}px`;
          canvas.style.height = `${bounds.height}px`;
          context.setTransform(ratio, 0, 0, ratio, 0, 0);
        };

        resize();
        pieces = Array.from({ length: 190 }, () => ({
          x: Math.random() * canvas.clientWidth,
          y: -20 - Math.random() * canvas.clientHeight * 0.65,
          w: 5 + Math.random() * 8,
          h: 8 + Math.random() * 12,
          vx: -1.7 + Math.random() * 3.4,
          vy: 2.5 + Math.random() * 4.5,
          spin: -0.18 + Math.random() * 0.36,
          angle: Math.random() * Math.PI,
          color: colors[Math.floor(Math.random() * colors.length)]
        }));

        const draw = (now) => {
          context.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight);
          pieces.forEach((piece) => {
            piece.x += piece.vx;
            piece.y += piece.vy;
            piece.vy += 0.025;
            piece.angle += piece.spin;
            context.save();
            context.translate(piece.x, piece.y);
            context.rotate(piece.angle);
            context.fillStyle = piece.color;
            context.fillRect(-piece.w / 2, -piece.h / 2, piece.w, piece.h);
            context.restore();
          });

          if (now - startedAt < confettiDuration) {
            animationFrame = requestAnimationFrame(draw);
          } else {
            context.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight);
          }
        };

        animationFrame = requestAnimationFrame(draw);
        window.addEventListener('resize', resize, { once: true });
        root.addEventListener('shopify:section:unload', () => cancelAnimationFrame(animationFrame), { once: true });
      };

      const finishGame = () => {
        if (finished) return;
        finished = true;
        cards.forEach((card) => {
          card.disabled = true;
        });
        launchConfetti();

        window.setTimeout(() => {
          complete.hidden = false;
          requestAnimationFrame(() => complete.classList.add('is-visible'));
        }, 650);

        if (redirectUrl && !(window.Shopify && window.Shopify.designMode)) {
          window.setTimeout(() => {
            window.location.assign(redirectUrl);
          }, redirectDelay);
        }
      };

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          if (finished || card.classList.contains('is-flipped') || selected >= required) return;

          const prize = prizes[selected] || {
            title: 'Prize unlocked',
            caption: '',
            image: '',
            icon: '🎁'
          };

          fillPrize(card, prize);
          card.classList.add('is-flipped');
          card.setAttribute('aria-pressed', 'true');
          card.querySelector('.ps-card-game__face--front').setAttribute('aria-hidden', 'false');
          selected += 1;
          count.textContent = `${selected}/${required}`;

          root.dispatchEvent(new CustomEvent('pretty-selfish:card-flipped', {
            bubbles: true,
            detail: { selected, required, prize: prize.title }
          }));

          if (selected === required) {
            window.setTimeout(finishGame, 720);
          }
        });
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('.ps-card-game').forEach(initGame);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
